import styled from "styled-components"

import { AlertsSection } from "./AlertsSection"
import { DevicesSection } from "./DevicesSection"
import { OrdersSection } from "./OrdersSection"
import { PerformanceTestsSection } from "./PerformanceTestsSection"
import { TotalDataSection } from "./TotalDataSection"
import { TrendsSection } from "./TrendsSection"

const Dashboard = styled.div`
  padding-bottom: 24px;

  @media only screen and (max-width: 768px) {
    padding: 12px 0 12px;
    margin: 0 -8px;
  }
`

const ContractorDashboard = () => {
  return (
    <Dashboard>
      <TotalDataSection />
      <TrendsSection />
      <DevicesSection />
      <OrdersSection />
      <AlertsSection />
      <PerformanceTestsSection />
    </Dashboard>
  )
}

export default ContractorDashboard
